import DynamicFormFieldDefinitionResourceModel from '../../generated/types/model/resource/DynamicFormFieldDefinitionResourceModel';

export default class DynamicFormFieldDefinitionResourceViewModel extends DynamicFormFieldDefinitionResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
